interface Closed {
  kind: 'closed';
}

interface Open {
  kind: 'open';
}

export const closed = (): Closed => ({ kind: 'closed' });

export const open = (): Open => ({ kind: 'open' });

export type State = Closed | Open;
